var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "rounded-l"
  }, [_c('v-card-title', {
    staticClass: "primary white--text grad"
  }, [_vm._v(" " + _vm._s(_vm.staff.user.name_first) + " " + _vm._s(_vm.staff.user.name_last) + " ")]), _c('v-card-subtitle', {
    staticClass: "primary white--text grad"
  }, [_vm._v(" " + _vm._s(_vm.staff.user.job_description) + " desctipion ")]), _c('v-card-text', {
    staticClass: "pa-4"
  }, [_c('v-list', [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-account")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.staff.user.username))]), _c('v-list-item-subtitle', [_c('span', [_vm._v("username")])])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-email")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm.staff.user.email ? _c('div', [_vm._v(_vm._s(_vm.location.email))]) : _vm._e(), _c('div', [_c('a', [_vm._v("Update")])])])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-phone")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm.staff.user.phone ? _c('span', [_vm._v(_vm._s(_vm.staff.user.phone))]) : _c('span', {
    staticClass: "font-italic"
  }, [_vm._v("Not recorded")])])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-shield")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Security")]), _c('v-list-item-subtitle', [_c('a', [_vm._v("Reset Password")])])], 1)], 1)], 1)], 1), _c('v-card-actions', {}, [_c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }